import { render, staticRenderFns } from "./integration-page.vue?vue&type=template&id=3740dbec&scoped=true&"
var script = {}
import style0 from "./integration-page.vue?vue&type=style&index=0&id=3740dbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740dbec",
  null
  
)

export default component.exports